module.exports = __webpack_public_path__ + "57ef8ca40dbedccb97ae9eb1acbf777d.jpg";